import styled from 'styled-components';
import { AvInput } from 'availity-mobx-reactstrap-validation';

export default styled(AvInput)`
  padding-left: 2rem;
  height: 3rem;
  font-size: 1.3rem;
  font-weight: 500;
  text-align: right;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`;
